import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import csrfToken from "@/landing/common/meta/csrf-token";

const Axios = {
  getAxios() {
    return axios;
  },

  init() {
    axios.defaults.withCredentials = true; // ! pane  tagasi true, katsetasin falsega
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    // this.csrfToken(); // ! Sanctumiga ei ole seda vaja.

    // axios.defaults.baseURL = baseurl;
    // window.axios = axios;
    Vue.use(VueAxios, axios);

    // axios.interceptors.response.use(
    //     response => response,
    //     error => {
    //         Vue.$notify(error.response.data.message);
    //         // console.log("JSON", error.toJSON());
    //         // if (parseInt(error.response.status) === 419)
    //         // handleCsrfExpireError(error.response.data);

    //         throw error;
    //     }
    // );
  },

  /**
   * Csrf is for post, put, delete requests.
   */
  csrfToken() {
    // ! sanctumiga pole vaja
    if (csrfToken) {
      axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    }
  },
};

export default Axios;
